import React, { memo, useContext, useMemo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Icon } from "@iconify/react";
import './lot-list-thumbnail.css';
import { lotContext } from "../../auction-lots-listing/components/lots-list-item/lots-list-item";
import GlobalHelper from "../../../helpers/global-helper";
import useImageGalleryFn from "../../modals/modal-image-gallery/useImageGalleryFn";

const LotListThumbnail = memo(() => {
    const { lotData } = useContext(lotContext);
    const { primary_image, title } = lotData;
    const { showModalImg } = useImageGalleryFn();

    // Мемоизированный URL изображения
    const imageUrl = useMemo(() => {
        return GlobalHelper.setImg(primary_image, true);
    }, [primary_image]);

    const showImage = (e) => {
        e.preventDefault();
        // Проверяем что primary_image существует и имеет viewUrl перед показом галереи
        if (primary_image && primary_image.viewUrl) {
            // Передаем primary_image как массив для совместимости с модальным окном
            showModalImg([primary_image]);
        }
    };

    return (
        <div className="product-list-img">
            <a href={imageUrl} data-action onClick={showImage}>
                <LazyLoadImage
                    className='preview img-fluid img-thumbnail shadow'
                    alt={title || 'Lot image'}
                    src={imageUrl}
                    data-action
                    effect="blur"
                    threshold={100}
                />
            </a>
            <div className="product-quickview">
                <a className='d-flex justify-content-center' href={imageUrl} data-action onClick={showImage}>
                    <i data-action className="sli sli-magnifier-add align-self-center">
                        <Icon icon="uil:search-plus" />
                    </i>
                </a>
            </div>
        </div>
    );
});

export default LotListThumbnail; 